import type { CategoryIdentifier } from "../../aysa_api/models/category_identifier.types";
import { Reader, Writer } from "protobufjs/minimal";
import type { Long } from "protoc-gen-ts";

export const createBaseCategoryIdentifier = (): CategoryIdentifier => {
  return {};
};

export const decodeCategoryIdentifier = (
  reader: Reader,
  length: number
): CategoryIdentifier => {
  const end = reader.pos + length;
  const message = createBaseCategoryIdentifier();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.identifier = {
          $case: "id",
          id: (reader.int64() as Long).toNumber(),
        };

        break;
      case 2:
        message.identifier = {
          $case: "legacyPath",
          legacyPath: reader.string(),
        };

        break;
      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeCategoryIdentifier = (
  writer: Writer,
  message: CategoryIdentifier
): Writer => {
  if (message.identifier !== undefined) {
    switch (message.identifier.$case) {
      case "id":
        writer.uint32(8).int64(message.identifier.id);

        break;
      case "legacyPath":
        writer.uint32(18).string(message.identifier.legacyPath);

        break;
    }
  }
  return writer;
};
